import React, { Component, Fragment } from "react";

import List from "../../../components/list/List";
import Pagination from "components/pagination/Pagination";
import clientsListColumn from "./ClientsList.utils";

class ClientsList extends Component {
  componentDidMount() {
    this.props.init("clients");
  }

  render() {
    const { clientsList, page, pages, pageSize, nbItems, getNext } = this.props;

    return (
      <div class="p-content-page-center p-content-page-center-full">
        <div class="p-content-page-center-header">
          <h2 class="p-content-page-center-header-title">Liste des clients</h2>
        </div>
        <div class="p-content-page-center-content">
          <List columns={clientsListColumn} data={clientsList} defaultText="Aucun client trouvé." />
          <div className="p-al-right p-mrg-ver">
            <Pagination page={page} pages={pages} pageSize={pageSize} nbItems={nbItems} getNext={getNext} />
          </div>{" "}
        </div>{" "}
      </div>
    );
  }
}

export default ClientsList;



// WEBPACK FOOTER //
// src/containers/admin/clients/ClientsList.js